import { ILoggingViewerProps } from "interfaces/Index";
import React from "react";
import "./LoggingViewer.scss";

const LoggingViewer: React.FunctionComponent<ILoggingViewerProps> = ({
  createdAt,
  createdBy,
  updatedAt,
  updatedBy,
}) => {
  return (
    <>
      <section className="logging-status-container">
        <section className="logging-status-detail">
          <div>
            <span>{`Created at ${createdAt}`}</span>
            <span>{createdBy && ` by ${createdBy}`}</span>
          </div>
        </section>
        {updatedBy && (
          <section className="logging-updated">
            <span>{`Last updated at ${updatedAt}`}</span>
            <span>{` by ${updatedBy}`}</span>
          </section>
        )}
      </section>
    </>
  );
};

export default LoggingViewer;
